import i18next from 'i18next';
import i18nEn from '@sap/ux-specification-types';
import { initI18n as initSyncI18n } from '../sync/i18n';

/**
 * Initializes i18next with the given language.
 *
 * @param language - The language code to initialize i18next with (default is 'en').
 */
export function initI18n(language = 'en'): void {
    // Initialize i18next of ide-extension
    i18next.init({
        resources: {
            en: {
                translation: i18nEn
            }
        },
        lng: language,
        fallbackLng: 'en',
        joinArrays: '\n\n',
        showSupportNotice: false
    });

    // Initialize i18next of core module
    initSyncI18n(i18next);
}
